export default __webpack_public_path__ + "static/media/2.28b91523.jpg";